<template>
  <Gallery category="cards" />
</template>

<script>
import Gallery from '@/components/Gallery'

export default {
  components: {
    Gallery,
  },
}
</script>
